<template>
  <div class="container">
    <el-card>
      <div slot="header">新增退水</div>
      <div class="centerBox">
        <div>选择水表：</div>
        <el-select v-model="model" placeholder="" size="small" clearable filterable>
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <div class="center_Con">
          <div class="content">
            <el-row :gutter="10">
              <el-col :span="8"> 商户编号：<span> Ffg </span> </el-col>
              <el-col :span="8"> 剩余水量（吨）：<span> 0 </span> </el-col>
              <el-col :span="8"> 累计购水次数：<span> 0 </span> </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="8"> 表号：<span> 01564444 </span> </el-col>
              <el-col :span="8"> 阀门开关：<span> 0 </span> </el-col>
              <el-col :span="8"> 累计金额（元）：<span> 0 </span> </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="8"> 商户名称：<span> 0 </span> </el-col>
              <el-col :span="8"> 强制模式：<span> 0 </span> </el-col>
              <el-col :span="8"> 累计水量（吨）：<span> </span> </el-col>
            </el-row>
          </div>
        </div>
        <div>
          <el-row :gutter="20">
            <el-col :span="12">
              <p>退电金额（元）</p>
              <el-input v-model="model" placeholder="" clearable></el-input>
            </el-col>
            <el-col :span="12">
              <p>付款方式</p>
              <el-select v-model="model" placeholder="" clearable>
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <p>备注</p>
              <el-input v-model="model" placeholder="" clearable></el-input>
            </el-col>
          </el-row>
        </div>

        <div style="margin-top: 20px; text-align: center">
          <el-button type="primary">退水</el-button>
          <el-button type="primary" plain>返回</el-button>
        </div>
      </div>
    </el-card>
    <!-- 打印信息提示 -->
    <el-dialog title="提示" :visible.sync="printInfoDialogVis" width="30%">
      <span>是否打印单据？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="printInfoDialogVis = false">取 消</el-button>
        <el-button type="primary" @click="printInfoDialogVis = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  created() {},
  mounted() {},
  watch: {},
  methods: {
  
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0 10px;
  height: 100%;
}
/deep/ .el-card__header {
  background-color: var(--secondColor) !important;
  color: var(--whiteColor);
}
@media screen and (max-width: 1000px) {
  .centerBox {
    width: 100% !important;
  }
}
.centerBox {
  width: 70%;
  margin: 0 auto;
  padding-top: 20px;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-form-item {
  margin-bottom: 10px;
}
.center_Con {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 20px;
  margin: 15px 0;
}
.el-row {
  line-height: 30px;
}
</style>
